<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Aliments</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter un aliment
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableFood"
          identifier="B122TableFood"
          init-b122-table-url="/food/initB122Table"
          get-b122-table-results-url="/food/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <food-delete-modal :selectedFood="ui.selectedFood" @didDeleteFood="didDeleteFood()"></food-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import FoodDeleteModal from "./FoodDeleteModal";

export default {

  name: 'FoodIndex',

  components: {
    B122Table,
    FoodDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Name",
          key: "name",
          sortable: true
        },
        {
          label: "Nombre d'espèces",
          key: "foodSpeciessCount",
          sortKey: "size(d.foodSpeciess)",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedFood: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'FoodCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'FoodShow',
        params: {
          foodId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'FoodEdit',
        params: {
          foodId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedFood = row.item
      this.$bvModal.show('food-delete-modal')
    },

    didDeleteFood() {
      this.ui.selectedFood = null;
      this.$refs.B122TableFood.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/food/FoodIndex.vue